export const manageErrors = (status: number) => {
    if (status === 400) {
        return 'Bad request, please check your request and try again';
    }
    if (status === 401) {
        return 'You are not authorized to access this resource';
    }
    if (status === 403) {
        return 'You are not authorized to access this resource';
    }
    if (status === 404) {
        return 'Resource not found';
    }
    if (status === 500) {
        return 'An error occurred while processing your request, please try again later';
    }
    return 'An error occurred while processing your request, please try again later';
};